<template lang="pug">
.audio-player.card
  .card-image
    figure.image.is-16x9
      .audio-only
        b-icon(icon="volume-high")
        small Audio-Only
      img(:src="artwork.file.url" v-if="artwork.id")
  .card-content.playback
    b-field(grouped)
      a.button.is-black.is-outlined.is-inverted(
        :class="{ 'is-loading': settings.loading }"
        @click="togglePlayback"
      )
        b-icon(:icon="playing ? 'pause' : 'play'")
    span.scrubber
      progress.progress.is-primary.is-small.is-link(
        :value="progress * 100"
        max="100"
        @click="scrub"
      )
      .level.is-mobile
        .level-left
          small {{ seek | timecode }}
        .level-right
          small {{ duration | timecode }}
</template>

<script>
import VueHowler from 'vue-howler';

export default {
  name: 'audio-player',
  created() {
    this.settings.loading = this._data._howl._state !== 'loaded';
    this.$on('load', () => {
      this.settings.loading = false;
    });
  },
  data() {
    return {
      settings: {
        loading: false,
      },
    };
  },
  mixins: [
    VueHowler,
  ],
  methods: {
    scrub($event) {
      const xPos = $event.layerX;
      const totalWidth = $event.srcElement.clientWidth;
      const prog = xPos / totalWidth;
      this.setProgress(prog);
    },
  },
  props: {
    artwork: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.audio-player {
  background-color: transparent;
  color: $white;
  .card-image {
    .audio-only {
      position: absolute;
      top: 10px;
      left: 10px;
      display: flex;
      .icon {
        padding-right: 4px;
      }
    }
  }
  .card-content {
    padding-left: 0;
    padding-right: 0;
  }
  .playback {
    display: flex;
    align-items: center;
    .field {
      margin-bottom: 0;
      a.button + a.button {
        margin-left: 8px;
      }
    }
    .scrubber {
      width: 100%;
      margin: 0 8px;
      progress {
        margin: 0 0 0.25rem 0;
        cursor: pointer;
      }
    }
  }
}
@media (max-width: $tablet) {
  .audio-player {
    margin-top: 12px;
    &.card {
      .card-image .image img {
        border-radius: 0;
      }
    }
    .playback {
      padding-left: $mobile-padding;
      padding-right: $mobile-padding;
    }
  }
}
</style>
